import { createRoutine } from 'redux-saga-routines'
import { call, put, takeLatest } from '@redux-saga/core/effects'
import { toast } from 'react-toastify'
import * as fileService from 'services/fileService'
import { getPortfolioFileInsight } from 'services/portfolioDocumentsService'
import { getApiErrors } from 'utils/errors'

// Action creators
export const getGuruInsightRoutine = createRoutine('GET_GURU_INSIGHT')
export const clearGuruInsightRoutine = createRoutine('CLEAR_GURU_INSIGHT')

// Saga functions
function* getGuruInsight({ payload }) {
  const { bpId, fileId, portfolioId } = payload
  yield put(getGuruInsightRoutine.request())
  try {
    const result = portfolioId
      ? yield call(getPortfolioFileInsight, portfolioId, fileId)
      : yield call(fileService.getGuruInsight, { bpId, fileId })
    yield put(getGuruInsightRoutine.success(result.data))
  } catch (error) {
    yield put(getGuruInsightRoutine.failure(getApiErrors(error)))
    const status = error?.response?.status
    if (status !== 401 && status !== 403 && status !== 404) {
      toast.error('Failed to get Guru Insight')
    }
  } finally {
    yield put(getGuruInsightRoutine.fulfill())
  }
}

// Root saga
export function* guruInsightSaga() {
  yield takeLatest(getGuruInsightRoutine.TRIGGER, getGuruInsight)
}
